var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
import { c as createSelector, r as react, s as setWithSelector, S as Store$1, h as hash } from "./store.js";
export { a as StorePersist } from "./store.js";
import React, { useCallback, useDebugValue, useMemo, createContext, useContext, useEffect } from "react";
import "immer";
var withSelector = { exports: {} };
var withSelector_production_min = {};
var shim = { exports: {} };
var useSyncExternalStoreShim_production_min = {};
/** @license React vundefined
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e = React;
function h$1(a2, b) {
  return a2 === b && (a2 !== 0 || 1 / a2 === 1 / b) || a2 !== a2 && b !== b;
}
var k = typeof Object.is === "function" ? Object.is : h$1, l = e.useState, m = e.useEffect, n$1 = e.useLayoutEffect, p$1 = e.useDebugValue;
function q$1(a2, b) {
  var d = b(), f = l({ inst: { value: d, getSnapshot: b } }), c = f[0].inst, g = f[1];
  n$1(function() {
    c.value = d;
    c.getSnapshot = b;
    r$1(c) && g({ inst: c });
  }, [a2, d, b]);
  m(function() {
    r$1(c) && g({ inst: c });
    return a2(function() {
      r$1(c) && g({ inst: c });
    });
  }, [a2]);
  p$1(d);
  return d;
}
function r$1(a2) {
  var b = a2.getSnapshot;
  a2 = a2.value;
  try {
    var d = b();
    return !k(a2, d);
  } catch (f) {
    return true;
  }
}
function t$1(a2, b) {
  return b();
}
var u$1 = typeof window === "undefined" || typeof window.document === "undefined" || typeof window.document.createElement === "undefined" ? t$1 : q$1;
useSyncExternalStoreShim_production_min.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u$1;
{
  shim.exports = useSyncExternalStoreShim_production_min;
}
/** @license React vundefined
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h = React, n = shim.exports;
function p(a2, b) {
  return a2 === b && (a2 !== 0 || 1 / a2 === 1 / b) || a2 !== a2 && b !== b;
}
var q = typeof Object.is === "function" ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
withSelector_production_min.useSyncExternalStoreWithSelector = function(a2, b, e2, l2, g) {
  var c = t(null);
  if (c.current === null) {
    var f = { hasValue: false, value: null };
    c.current = f;
  } else
    f = c.current;
  c = v(function() {
    function a3(a4) {
      if (!c2) {
        c2 = true;
        d2 = a4;
        a4 = l2(a4);
        if (g !== void 0 && f.hasValue) {
          var b2 = f.value;
          if (g(b2, a4))
            return k2 = b2;
        }
        return k2 = a4;
      }
      b2 = k2;
      if (q(d2, a4))
        return b2;
      var e3 = l2(a4);
      if (g !== void 0 && g(b2, e3))
        return b2;
      d2 = a4;
      return k2 = e3;
    }
    var c2 = false, d2, k2, m2 = e2 === void 0 ? null : e2;
    return [function() {
      return a3(b());
    }, m2 === null ? void 0 : function() {
      return a3(m2());
    }];
  }, [b, e2, l2, g]);
  var d = r(a2, c[0], c[1]);
  u(function() {
    f.hasValue = true;
    f.value = d;
  }, [d]);
  w(d);
  return d;
};
{
  withSelector.exports = withSelector_production_min;
}
function useStoreState(store, ...args) {
  var _a, _b, _c, _d;
  let selector, options;
  if (args[0] instanceof Function) {
    selector = args[0];
    options = (_a = args[1]) != null ? _a : {};
  } else if (typeof args[0] === "string") {
    selector = createSelector(args[0]);
    options = (_b = args[1]) != null ? _b : {};
  } else {
    selector = (x) => x;
    options = (_c = args[0]) != null ? _c : {};
  }
  const subscribe = useCallback((listener) => {
    return store.subscribe((x) => x, listener, {
      throttle: options.throttle,
      runNow: false,
      compare: (a2, b) => a2 === b
    });
  }, [store, options.throttle]);
  const getSnapshot = useCallback(() => store.getState(), [store]);
  const value = withSelector.exports.useSyncExternalStoreWithSelector(subscribe, getSnapshot, getSnapshot, selector, (_d = options.compare) != null ? _d : react);
  useDebugValue(value);
  return value;
}
function useStoreProp(store, selector) {
  const value = useStoreState(store, selector);
  const update = (value2) => store.update((state) => setWithSelector(state, selector, value2));
  return [value, update];
}
class Store extends Store$1 {
  useState(...args) {
    return useStoreState(this, ...args);
  }
  useProp(selector) {
    return useStoreProp(this, selector);
  }
}
class StoreScope {
  constructor(defaultValue) {
    this.defaultValue = defaultValue;
    this.Provider = ({ children, store }) => {
      const _store = useMemo(() => store != null ? store : new Store(this.defaultValue), [store]);
      return /* @__PURE__ */ React.createElement(this.context.Provider, {
        value: _store
      }, children);
    };
    this.withScope = (Component) => {
      return (args) => /* @__PURE__ */ React.createElement(this.Provider, null, /* @__PURE__ */ React.createElement(Component, __spreadValues({}, args)));
    };
    this.context = createContext(new Store(defaultValue));
  }
  useStore() {
    return useContext(this.context);
  }
  useState(...args) {
    const store = this.useStore();
    return useStoreState(store, ...args);
  }
  useProp(selector) {
    const store = this.useStore();
    return useStoreProp(store, selector);
  }
}
function useResource(resource, options) {
  const { compare, dormant, throttle, updateOnMount, watchOnly } = options != null ? options : {};
  useEffect(() => {
    if (updateOnMount && !dormant) {
      resource.invalidateCache();
    }
  }, []);
  const subscribe = useCallback((listener) => {
    if (dormant)
      return () => {
      };
    return resource.subscribe(listener, {
      watchOnly,
      throttle,
      runNow: false,
      compare
    });
  }, [resource.id, watchOnly, dormant, throttle]);
  const getSnapshot = useCallback(() => resource.getCache(), [resource.id]);
  let value = withSelector.exports.useSyncExternalStoreWithSelector(subscribe, getSnapshot, getSnapshot, (x) => x, react);
  if (dormant) {
    value = { state: "empty", isLoading: false };
  }
  useDebugValue(value);
  return value;
}
function useReadResource(resource, options) {
  const info = useResource(resource, options);
  if (info.state === "error") {
    throw info.error;
  }
  if (info.state === "empty") {
    throw resource.get();
  }
  useDebugValue(info.value);
  return info.value;
}
function combineResources(...resources) {
  return {
    id: hash(resources.map((resource) => resource.id)),
    invalidateCache() {
      for (const resource of resources) {
        resource.invalidateCache();
      }
    },
    subscribe(listener, options) {
      const handles = resources.map((resource) => resource.subscribe(listener, options));
      return () => {
        for (const handle of handles) {
          handle();
        }
      };
    },
    getCache() {
      var _a;
      const caches = resources.map((resource) => resource.getCache());
      const isStale = caches.some((cache) => cache.isStale);
      const isLoading = caches.some((cache) => cache.isLoading);
      if (caches.some((resource) => resource.state === "error")) {
        const error = (_a = caches.find((cache) => cache.error !== void 0)) == null ? void 0 : _a.error;
        return { state: "error", error, isStale, isLoading };
      }
      if (caches.every((resource) => resource.state === "value")) {
        const value = caches.map((cache) => cache.value);
        return { state: "value", value, isStale, isLoading };
      }
      return { state: "empty", isLoading };
    },
    get() {
      return Promise.all(resources.map((resource) => resource.get()));
    }
  };
}
export { Store, StoreScope, combineResources, useReadResource, useResource, useStoreState };
//# sourceMappingURL=react.js.map
